import type { ComponentType } from 'react'
import type { RouteObject } from 'react-router-dom'
import { createPermissionGuardedPage } from '@/shared/components/create-permission-guarded-page'
import { importWithChunkReload } from '@/shared/lib/chunk-load-recovery'
import { SupervisorStaffDocsPermissions } from './permissions'

async function lazyGuardedRoute(
  importPage: () => Promise<Record<string, ComponentType>>,
  exportName: string,
): Promise<{ Component: ComponentType }> {
  const mod = await importWithChunkReload(importPage)
  const Page = mod[exportName]
  if (!Page) {
    throw new Error(`Supervisor staff-docs route page export "${exportName}" not found`)
  }
  return {
    Component: createPermissionGuardedPage(SupervisorStaffDocsPermissions.access, Page, {
      mode: 'any',
      administratorBypass: true,
    }),
  }
}

export const supervisorStaffDocsRoutes: RouteObject[] = [
  {
    path: 'supervisor/staff-documents',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/supervisor-staff-docs-list-page'),
        'SupervisorStaffDocsListPage',
      ),
  },
  {
    path: 'supervisor/staff-documents/:employeeId',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/supervisor-staff-docs-detail-page'),
        'SupervisorStaffDocsDetailPage',
      ),
  },
]
